export const BooleanValues = () => null; // boolean fields have no values
